import { createQueryKeys } from '@lukemorales/query-key-factory';
import {
  type GetCouponGoodsCategoriesServiceRequest,
  type GetCouponGoodsCountServiceRequest,
  type GetCouponGoodsServiceRequest,
  getCouponCountService,
  getCouponGoodsCategoriesService,
  getCouponGoodsCountService,
  getCouponGoodsService,
  getCouponsService,
} from '@musinsa/services-curator';

export const couponFactory = createQueryKeys('coupon', {
  list: (shopTitle: string) => ({
    queryKey: ['list', shopTitle],
    queryFn: ({ pageParam = 1 }: { pageParam?: number }) =>
      getCouponsService({ shopTitle, page: pageParam, size: 20 }),
  }),
  count: (snsTitle: string) => ({
    queryKey: ['count', snsTitle],
    queryFn: () => getCouponCountService({ shopTitle: snsTitle }),
  }),
  goods: (request: GetCouponGoodsServiceRequest) => ({
    queryKey: ['goods', request],
    queryFn: () => getCouponGoodsService(request),
  }),
  goodsInfinite: (request: GetCouponGoodsServiceRequest) => ({
    queryKey: ['goodsInfinite', request],
    queryFn: ({ pageParam = 1 }: { pageParam?: number }) =>
      getCouponGoodsService({ ...request, page: pageParam, size: 20 }),
  }),
  goodsCategories: (request: GetCouponGoodsCategoriesServiceRequest) => ({
    queryKey: ['goodsCategories', request],
    queryFn: () => getCouponGoodsCategoriesService(request),
  }),
  goodsCount: (request: GetCouponGoodsCountServiceRequest) => ({
    queryKey: ['goodsCount', request],
    queryFn: () => getCouponGoodsCountService(request),
  }),
});
